export const getAvatarName = fullName => {
  if (!fullName) return '';
  let name = fullName;
  // Check if the name contains an '@', indicating it's an email
  if (name.includes('@')) {
    // Extract the part of the email before the '@'
    const emailNamePart = name.split('@')[0];
    // Replace dots with spaces to treat each part separated by dot as a different name part
    name = emailNamePart.replace(/\./g, ' ');
  }

  const names = name.trim().split(/\s+/); // Split by one or more spaces
  if (names.length === 1) {
    // If there's only one part to the name, use the first character of this part
    return names[0][0].toUpperCase();
  }
  // Use the first character of the first and last parts, both converted to uppercase
  return `${names[0][0]}${names[names.length - 1][0]}`.toUpperCase();
};
